import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, ProgressBar } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import "../../styles/reportform.css"; // Optional: For custom styles
import api from "../../api.js";

const ReportForm = ({ show, handleClose, subjectId, onSuccess }) => {
  const [step, setStep] = useState(1);
  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [keyPoints, setKeyPoints] = useState("");
  const [file, setFile] = useState(null);
  const [picture, setPicture] = useState(null);
  const [relatedSubjects, setRelatedSubjects] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = Cookies.get("access_token");
  const user = Cookies.get("user_id");

  useEffect(() => {
    if (show) {
      setStep(1);
      api
        .get("/subject/", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setAllSubjects(res.data);
        })
        .catch(() => {
          console.error("Error loading subjects");
        });
    }
  }, [show, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("لطفاً فایل گزارش را انتخاب کنید.");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("summary", summary);
    formData.append("key_points", keyPoints);
    formData.append("file", file);
    if (picture) formData.append("picture", picture);
    formData.append("author", user);
    formData.append("subject_id", subjectId);
    relatedSubjects.forEach((id) => formData.append("related_subjects", id));

    setLoading(true);
    try {
      await api.post(`/report/subject/${subjectId}/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      onSuccess();
      handleClose();
    } catch (err) {
      console.error("Error uploading report:", err);
      alert("خطا در ارسال گزارش.");
    } finally {
      setLoading(false);
    }
  };

  const renderStepIndicator = () => (
    <div className="d-flex justify-content-center align-items-center mb-4 step-indicator">
      <div className={`step ${step === 1 ? "active" : ""}`}>۱</div>
      <div className={`step-line ${step === 2 ? "filled" : ""}`} />
      <div className={`step ${step === 2 ? "active" : ""}`}>۲</div>
    </div>
  );

  const renderStep1 = () => (
    <>
      <Form.Group className="mb-3">
        <Form.Label>عنوان گزارش</Form.Label>
        <Form.Control
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>خلاصه گزارش</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>نکات کلیدی</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={keyPoints}
          onChange={(e) => setKeyPoints(e.target.value)}
        />
      </Form.Group>
    </>
  );

  const [searchTerm, setSearchTerm] = useState("");

// filter subjects by search term
const filteredSubjects = allSubjects.filter((subject) =>
  subject.title.toLowerCase().includes(searchTerm.toLowerCase())
);

const renderStep2 = () => (
  <>
    <Form.Group className="mb-3">
      <Form.Label>فایل گزارش (PDF)</Form.Label>
      <Form.Control
        type="file"
        accept="application/pdf"
        onChange={(e) => setFile(e.target.files[0])}
        required
      />
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>تصویر </Form.Label>
      <Form.Control
        type="file"
        accept="image/*"
        onChange={(e) => setPicture(e.target.files[0])}
      />
    </Form.Group>

    {/* ✅ Related Subjects with Search + Checkbox List */}
    <Form.Group className="mb-3">
      <Form.Label>موضوعات مرتبط</Form.Label>

      {/* Search Box */}
      <Form.Control
        type="text"
        placeholder="جستجو در موضوعات..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-2"
      />

      {/* Scrollable Checkbox List */}
      <div className="scrollable-checkbox-list">
        {filteredSubjects.length > 0 ? (
          filteredSubjects.map((subject) => (
            <Form.Check
              key={subject.id}
              type="checkbox"
              label={subject.title}
              checked={relatedSubjects.includes(String(subject.id))}
              onChange={(e) => {
                const isChecked = e.target.checked;
                const id = String(subject.id);
                setRelatedSubjects((prev) =>
                  isChecked
                    ? [...prev, id]
                    : prev.filter((sid) => sid !== id)
                );
              }}
            />
          ))
        ) : (
          <div className="text-muted text-center">موضوعی یافت نشد.</div>
        )}
      </div>
    </Form.Group>
  </>
);


  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {renderStepIndicator()}
          {step === 1 ? renderStep1() : renderStep2()}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <div>
            {step > 1 && (
              <Button className="previous" variant="outline-secondary" onClick={() => setStep(step - 1)}>
                قبلی
              </Button>
            )}
          </div>
          <div>
            {step < 2 ? (
              <Button className="next" variant="primary" onClick={() => setStep(step + 1)}>
                بعدی
              </Button>
            ) : (
              <Button className="submit" type="submit" variant="success" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "ارسال"}
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ReportForm;
